import {
  SET_LOAN_EDITING,
  SET_LOAN_BALANCE_EDITING,
  CREATE_LOAN_BALANCE_REQUEST,
  CREATE_LOAN_BALANCE_SUCCESS,
  CREATE_LOAN_BALANCE_FAILURE
} from './actionTypes'

import { submitLoanBalance } from '../api/mikasa/requests'
import { flashNotification } from './.'
import { fetchHomeDetail } from './home'
import { LOAN_BALANCE, ERRORS } from '../constants/messages'

export const editLoan = loan => ({
  type: SET_LOAN_EDITING,
  editing: true,
  currentLoan: loan
})

export const cancelEdit = () => ({
  type: SET_LOAN_EDITING,
  editing: false,
  currentLoan: null
})

export const addLoan = () => ({
  type: SET_LOAN_EDITING,
  editing: true,
  currentLoan: {}
})

export const editBalance = loan => ({
  type: SET_LOAN_BALANCE_EDITING,
  editingBalance: true,
  currentLoan: loan
})

export const cancelEditBalance = () => ({
  type: SET_LOAN_BALANCE_EDITING,
  editingBalance: false,
  currentLoan: null
})

export const createBalance =
  ({ homeId, loanId, value, date }) =>
  async dispatch => {
    dispatch({ type: CREATE_LOAN_BALANCE_REQUEST })

    try {
      await submitLoanBalance(loanId, value, date)
      await dispatch(fetchHomeDetail(homeId))
      await dispatch(
        flashNotification({
          message: LOAN_BALANCE.balanceIncreasedSuccessMessage,
          messageType: 'error'
        })
      )
      await dispatch({ type: CREATE_LOAN_BALANCE_SUCCESS })
      await dispatch(cancelEditBalance())
    } catch (error) {
      dispatch({ type: CREATE_LOAN_BALANCE_FAILURE })
      dispatch(
        flashNotification({
          message: [ERRORS.defaultHeadline, ERRORS.defaultMessage],
          messageType: 'error'
        })
      )
    }
  }
